module.exports = __webpack_public_path__ + "static/media/forgotScreen.70543469.png";